import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZKpiItem = z.object({
  id: z.string(),
  name: z.string()
})

const ZKpiData = z.object({
  total_count: z.number(),
  kpiList: ZKpiItem.array()
})

const ZKpiApiResponse = z.object({
  http_status: z.number(),
  error: z.boolean(),
  data: z.optional(ZKpiData)
})

export type KpiItem = z.infer<typeof ZKpiItem>
export type KpiData = z.infer<typeof ZKpiData>

export async function getDiagnosticKpiList (
  assetId: string,
  onSuccess: (kpiData: KpiData) => any,
  onFailure: (errorMessage: any) => any
): Promise<void> {
  const url = `/kpi-service/api/v1/udp/kpis/table-list/${assetId}`

  interceptedAxios.get(url)
    .then((response) => {
      // istanbul ignore else
      if (response.status === 200) {
        const parseResponse = ZKpiApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          // istanbul ignore else
          if (parseResponse.data.data !== null && parseResponse.data.data !== undefined) {
            onSuccess(parseResponse.data.data)
          } else {
            onFailure('No data received')
          }
        } else {
          onFailure(parseResponse.error.message)
        }
      }
    })
    .catch((error) => {
      onFailure(error.message)
    })
}
